import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import reducerGenerator from '../hierarchyAssignmentsPanelTab/reducerGenerator'
import * as EntitiesActionTypes from '../../../entities/actionTypes'
import {arrayToSet, filterArrayByKeys} from '../../../atUtils'

const hierarchyAssignmentsPanelReducer = reducerGenerator({
    actionTypes: ActionTypes
})

const initialState = {
    ...hierarchyAssignmentsPanelReducer.initialState,
    showCopyContent: false,
    copyContent: {
        userId: null,
        loading: false,
        counters: {
            task: 0,
            project: 0,
            customer: 0,
        },
        usersForSelector: [],
    },
}

const managementAssignmentsPanel = handleActions({
    ...hierarchyAssignmentsPanelReducer.handlers,
    [ActionTypes.COPY_CONTENT_OPEN] : (state) => ({
        ...state,
        showCopyContent: true,
        copyContent: {
            ...state.copyContent,
            userId: null,
            loading: false,
            counters: {
                tasks: 0,
                projects: 0,
                customers: 0,
            },
        },
    }),
    [ActionTypes.COPY_CONTENT_CLOSE] : (state) => ({
        ...state,
        showCopyContent: false,
    }),
    [ActionTypes.COPY_USER_ID_SET]: (state, {payload: userId}) => ({
        ...state,
        copyContent: {
            ...state.copyContent,
            userId,
        }
    }),
    [ActionTypes.COPY_LOADING_SET]: (state, {payload: loading}) => ({
        ...state,
        copyContent: {
            ...state.copyContent,
            loading,
        }
    }),
    [ActionTypes.COPY_COUNTERS_SET]: (state, {payload: counters}) => ({
        ...state,
        copyContent: {
            ...state.copyContent,
            counters,
        }
    }),
    [ActionTypes.COPY_USER_IDS_FOR_SELECTOR_SET]: (state, {payload: usersForSelector}) => ({
        ...state,
        copyContent: {
            ...state.copyContent,
            usersForSelector,
        }
    }),
    [EntitiesActionTypes.USERS_REMOVE]: (state, {payload: ids}) => ({
        ...state,
        copyContent: {
            ...state.copyContent,
            usersForSelector: filterArrayByKeys(state.copyContent.usersForSelector, ids, u => u.id),
        }
    }),
}, initialState)

export default managementAssignmentsPanel



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/editManagementAssignmentsPanel/reducer.js